module.exports = __webpack_public_path__ + "img/verify-failed.fa918016.png";